// import {
//     RendererFormControl,
//     FormControlType,
//     AddressOptions
// } from "../typings";
import { BaseControl } from "@cloudpivot/form/src/common/controls/base-control";
// import { BaseControl } from "./base-control";
// import { FromAddressValueService } from '../services';
export class AddressControl extends BaseControl {
    constructor() {
        super(...arguments);
        this.pca = {};
        this.val = {};
    }
    get address() {
        // debugger
        return this.val.address || '';
    }
    setControl() {
        this.handleValueChange(this.ctrl.value);
    }
    handleValueChange(value) {
        if (value) {
            this.val = value;
        }
        else {
            this.val = {};
        }
        this.setPcaDate();
    }
    // created() {
    //     debugger
    //     this
    // }
    valueChange(val) {
        // debugger
        let value = {};
        const { address } = this.val;
        if (address) {
            value.address = address;
        }
        value = Object.assign(value, val);
        this.ctrl.value = value;
        this.setPcaDate();
    }
    setPcaDate() {
        if (this.ctrl.value) {
            this.pca = JSON.parse(JSON.stringify(this.ctrl.value));
            delete this.pca.address;
        }
        else {
            this.pca = {};
        }
    }
    get showEmpty() {
        return this.controlOpts.showEmpty === 'true';
    }
    get addressString() {
        // debugger
        if (!this.ctrl.value)
            return '';
        const { provinceName, cityName, districtName, address } = this.ctrl.value;
        const addressList = [];
        addressList.push(provinceName, cityName, districtName, address);
        const str = addressList.reduce((strItem, current) => {
            let currentStr = '';
            let beforeStr = '';
            if (current) {
                currentStr = current;
            }
            if (strItem) {
                beforeStr = strItem;
            }
            return `${beforeStr} ${currentStr}`;
        });
        return str;
    }
}
